import "./styles.css";
import { applyLanguage, copy, getInitialLanguage, type ContentKey, type Language } from "./content";
import { initializeLightbox } from "./lightbox";
import { mediaItems, renderGallery } from "./media";

const menuButton = document.querySelector<HTMLButtonElement>("#menu-button");
const navigation = document.querySelector<HTMLElement>("#primary-navigation");

function initializeNavigation(): void {
  menuButton?.addEventListener("click", () => {
    const open = menuButton.getAttribute("aria-expanded") !== "true";
    menuButton.setAttribute("aria-expanded", String(open));
    navigation?.classList.toggle("primary-nav--open", open);
    const language: Language = document.documentElement.lang === "uk" ? "uk" : "en";
    const label: ContentKey = open ? "menuClose" : "menuOpen";
    menuButton.setAttribute("aria-label", copy[language][label]);
  });

  navigation?.addEventListener("click", (event) => {
    if (!(event.target as HTMLElement).closest("a")) return;
    menuButton?.setAttribute("aria-expanded", "false");
    navigation.classList.remove("primary-nav--open");
  });
}

document.querySelectorAll<HTMLButtonElement>("[data-language]").forEach((button) => {
  button.addEventListener("click", () => applyLanguage(button.dataset.language === "uk" ? "uk" : "en"));
});

window.addEventListener("parish-language-change", () => renderGallery());

renderGallery();
initializeLightbox(mediaItems);
initializeNavigation();
applyLanguage(getInitialLanguage());
